import React from "react";

const ThemeContext = React.createContext({
  test: 1234567890,
  setTest: () => {},
});

export default ThemeContext;
